<div class="redirect-modal">
  <header class="rd-header">
    <div class="rd-icon" [ngClass]="'rd-icon--' + phase" aria-hidden="true">
      <div class="rd-icon__core">
        <mat-icon [class.rd-icon__spin]="phase === 'confirm'">{{ icon }}</mat-icon>
      </div>
    </div>

    <div class="rd-heading" [ngSwitch]="phase">
      <ng-container *ngSwitchCase="'confirm'">
        <h2 id="sso-redirect-title" class="rd-title">Redirecionamento seguro</h2>
        <p class="rd-subtitle">Você será redirecionado para <strong>{{ data.appTitle }}</strong></p>
      </ng-container>

      <ng-container *ngSwitchCase="'success'">
        <h2 id="sso-redirect-title" class="rd-title">Redirecionando…</h2>
        <p class="rd-subtitle" role="status">Abrindo <strong>{{ data.appTitle }}</strong></p>
      </ng-container>

      <!-- App sem base URL no ambiente atual: integração ainda indisponível -->
      <ng-container *ngSwitchCase="'wip'">
        <h2 id="sso-redirect-title" class="rd-title">Em construção</h2>
        <p class="rd-subtitle">Ainda estamos trabalhando na integração de <strong>{{ data.appTitle }}</strong></p>
      </ng-container>
    </div>
  </header>

  <ng-container [ngSwitch]="phase">
    <ng-container *ngSwitchCase="'confirm'">
      <p class="rd-note">
        <mat-icon aria-hidden="true">lock</mat-icon>
        Conexão segura via single sign-on corporativo
      </p>
      <div class="rd-footer">
        <button type="button" class="rd-btn rd-btn--ghost" (click)="cancel()">Cancelar</button>
        <button type="button" class="rd-btn rd-btn--primary" (click)="confirm()">Continuar</button>
      </div>
    </ng-container>

    <div *ngSwitchCase="'wip'" class="rd-footer rd-footer--end">
      <button type="button" class="rd-btn rd-btn--primary" (click)="cancel()">Entendi</button>
    </div>
  </ng-container>
</div>
